export const CONTRACT_STATUS_ACTIVE = 1;

export const CONTRACT_STATUS_REFUSED = -3;

export const REFUSAL_REASON_MAX_LENGTH = 1000;
